export const formatSalonUrl = (salon: string): string => {
  const salonMap: Record<string, string> = {
    "Ville d'Avray": "ville-d-avray",
    Villejuif: "villejuif",
    "Au Grey des couleurs": "au-grey-des-couleurs",
  };

  return `/le-salon/${salonMap[salon] || salon.toLowerCase().replace(/ /g, "-")}`;
};
